import { render, staticRenderFns } from "./HeaderSoftware.vue?vue&type=template&id=1c976dd2&"
import script from "./HeaderSoftware.vue?vue&type=script&lang=js&"
export * from "./HeaderSoftware.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSoftware.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports